import { render, staticRenderFns } from "./Docker.vue?vue&type=template&id=c72adfa8&scoped=true"
import script from "./Docker.vue?vue&type=script&lang=js"
export * from "./Docker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72adfa8",
  null
  
)

export default component.exports